import { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import PageSEO from "@/components/PageSEO";
import { ARTICLES } from "@/lib/articles";

export default function Blog() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div data-testid="blog-page" className="min-h-screen bg-[#FAFAF9] text-stone-900">
      <PageSEO
        title="Blog · Guías de Tuxpan, Veracruz y hospedaje frente al mar"
        description="Historias, naturaleza y consejos del Golfo de México. Guías para viajar a Tuxpan y Barra de Galindo, qué hacer, cómo llegar desde CDMX, mejores temporadas y gastronomía local."
        keywords="blog tuxpan veracruz, guias barra de galindo, que hacer tuxpan, como llegar tuxpan cdmx, mejores playas veracruz, hospedaje frente al mar"
        path="/blog"
        imageAlt="Blog de Villas Pura Vida — guías de Tuxpan Veracruz"
        type="website"
        structuredData={{
          "@context": "https://schema.org",
          "@type": "Blog",
          name: "Blog Villas Pura Vida",
          description: "Guías de viaje y vida de playa en Tuxpan, Veracruz",
          url: "https://puravidatuxpan.com/blog",
          publisher: {
            "@type": "Organization",
            name: "Villas Pura Vida",
            url: "https://puravidatuxpan.com",
          },
          blogPost: ARTICLES.map((a) => ({
            "@type": "BlogPosting",
            headline: a.title,
            url: `https://puravidatuxpan.com/blog/${a.slug}`,
            datePublished: a.date,
            description: a.meta_description,
          })),
        }}
      />      <Header variant="home" />
      <main className="pt-32 md:pt-40 pb-24 max-w-7xl mx-auto px-6 md:px-10">
        <p className="text-eyebrow text-[#E07A5F] mb-4">Blog · Villas Pura Vida</p>
        <h1 className="font-serif-display text-5xl md:text-7xl leading-[0.95] tracking-tight mb-6 max-w-3xl">
          Historias, naturaleza y consejos del Golfo de México.
        </h1>
        <p className="text-stone-600 text-lg max-w-2xl mb-16">
          Guías para viajar a Tuxpan, datos sobre Veracruz, neurociencia del mar y todo lo que pasa entre la arena y las olas en Barra de Galindo.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {ARTICLES.map((a, i) => (
            <Link
              key={a.slug}
              to={`/blog/${a.slug}`}
              data-testid={`blog-card-${a.slug}`}
              className="group block bg-white border border-stone-200 hover:border-stone-400 transition-all hover:-translate-y-1"
            >
              <div className="aspect-[5/4] overflow-hidden bg-stone-200">
                <img
                  src={a.hero}
                  alt={a.title}
                  loading={i < 3 ? "eager" : "lazy"}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-[1500ms] ease-out"
                />
              </div>
              <div className="p-6">
                <div className="flex items-center gap-3 mb-3 text-eyebrow text-stone-500">
                  <span className="text-[#E07A5F]">{a.category}</span>
                  <span>·</span>
                  <span>{a.read_time}</span>
                </div>
                <h2 className="font-serif-display text-2xl md:text-3xl leading-[1.1] text-stone-900 group-hover:text-[#E07A5F] transition-colors mb-3">
                  {a.title}
                </h2>
                <p className="text-sm text-stone-600 leading-relaxed line-clamp-3">
                  {a.meta_description}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </main>
      <Footer />
    </div>
  );
}
